import React, { useId } from 'react';

type SVGIconProps = React.SVGProps<SVGSVGElement>;

export const CompassSVG = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="28.991"
			height="28.991"
			viewBox="0 0 28.991 28.991">
			<g data-name="compass_tab" transform="translate(1509.596 -797.155)">
				<path
					data-name="compass_path1"
					d="M13.836,2A11.836,11.836,0,0,1,22.2,22.2,11.836,11.836,0,1,1,5.467,5.467,11.758,11.758,0,0,1,13.836,2Zm0,21.671A9.836,9.836,0,1,0,4,13.836,9.847,9.847,0,0,0,13.836,23.671Z"
					transform="matrix(0.259, -0.966, 0.966, 0.259, -1512.045, 821.434)"
				/>
				<path
					data-name="compass_path1"
					d="M8.876,11.254h0L3.444,7.668,8.487,4.786l.388,6.465ZM2.768,6.5v0L2.378,0,7.837,3.6,2.77,6.5Z"
					transform="translate(-1500.727 806.024)"
				/>
			</g>
		</svg>
	);
};

export const MapSVG = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="22.396"
			height="18.455"
			viewBox="0 0 22.396 18.455">
			<g data-name="map_tab" transform="translate(1474.254 -868.914)">
				<path
					data-name="map_path1"
					d="M1.285-1.65,6.44-2.885a.428.428,0,0,1,.428.428V13.819a.428.428,0,0,1-.428.428L1.285,15.483A1.285,1.285,0,0,1,0,14.2V-.365C0-1.074.366-1.349,1.285-1.65Z"
					transform="translate(-1474.254 871.885)"
				/>
				<path
					data-name="map_path2"
					d="M5.583,14.247.428,15.483A.428.428,0,0,1,0,15.055V-1.221A.428.428,0,0,1,.428-1.65L5.583-2.885A1.285,1.285,0,0,1,6.868-1.6V12.962C6.868,13.672,6.5,13.947,5.583,14.247Z"
					transform="translate(-1458.726 871.799)"
				/>
				<path
					data-name="map_path3"
					d="M.428,0l5.9,1.2a.428.428,0,0,1,.428.428V17.9a.428.428,0,0,1-.428.428l-5.9-1.2A.428.428,0,0,1,0,16.7V.428A.428.428,0,0,1,.428,0Z"
					transform="translate(-1466.435 868.951)"
				/>
			</g>
		</svg>
	);
};

export const CollectionsSVG = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24.673"
			height="22.516"
			viewBox="0 0 24.673 22.516">
			<path
				data-name="collection_path1"
				d="M.644,9.1l5.033,2.925,5.937,3.622h0a1.3,1.3,0,0,0,1.344,0l4.4-2.666,6.665-3.845a1.294,1.294,0,0,0,0-2.24L17.24,2.953,13.012.208a1.294,1.294,0,0,0-1.406,0L6.714,3.362.647,6.861a1.294,1.294,0,0,0,0,2.24"
				transform="translate(0 0)"
			/>
			<path
				data-name="collection_path2"
				d="M.646,42.01l5.038,2.917,5.942,3.612h0a1.294,1.294,0,0,0,1.344,0l4.4-2.673,6.659-3.856A1.275,1.275,0,0,0,24.668,41a1.291,1.291,0,0,0-.453-1.1L17.9,43.56l-4.389,2.668a2.329,2.329,0,0,1-2.42,0L5.156,42.621.458,39.9A1.292,1.292,0,0,0,.005,41,1.277,1.277,0,0,0,.646,42.01"
				transform="translate(0 -29.576)"
			/>
			<path
				data-name="collection_path3"
				d="M24.216,52.9,17.9,56.56l-4.389,2.668a2.329,2.329,0,0,1-2.42,0L5.156,55.621.458,52.9A1.291,1.291,0,0,0,.005,54,1.277,1.277,0,0,0,.646,55.01l5.038,2.917,5.942,3.612h0a1.294,1.294,0,0,0,1.344,0l4.4-2.673,6.659-3.856A1.276,1.276,0,0,0,24.668,54a1.291,1.291,0,0,0-.453-1.1"
				transform="translate(0 -39.211)"
			/>
		</svg>
	);
};

export const BookmarksSVG = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="13.708"
			height="18.278"
			viewBox="0 0 13.708 18.278">
			<path
				data-name="bookmarks_tab"
				d="M0,18.278V1.714A1.714,1.714,0,0,1,1.714,0H11.995a1.714,1.714,0,0,1,1.714,1.714V18.278l-6.854-4Z"
			/>
		</svg>
	);
};

export const VideoIcon: React.FC = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="28.23"
			height="18.82"
			viewBox="0 0 28.23 18.82">
			<path
				data-name="Video Icon"
				d="M16.477,4.5H2.343A2.343,2.343,0,0,0,0,6.843V20.977A2.343,2.343,0,0,0,2.343,23.32H16.477a2.343,2.343,0,0,0,2.343-2.343V6.843A2.343,2.343,0,0,0,16.477,4.5ZM25.76,6.348l-5.372,3.705v7.714l5.372,3.7A1.571,1.571,0,0,0,28.23,20.2V7.612A1.572,1.572,0,0,0,25.76,6.348Z"
				transform="translate(0 -4.5)"
			/>
		</svg>
	);
};

export const AudioIcon: React.FC = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="26.399"
			height="22"
			viewBox="0 0 26.399 22">
			<path
				data-name="Audio Icon"
				d="M9.855,3.648,5.777,7.725H1.1A1.1,1.1,0,0,0,0,8.825v6.6a1.1,1.1,0,0,0,1.1,1.1H5.777L9.855,20.6a1.1,1.1,0,0,0,1.878-.778V4.426A1.1,1.1,0,0,0,9.855,3.648ZM20.548,1.307a1.109,1.109,0,1,0-1.217,1.854,10.708,10.708,0,0,1,0,17.927,1.109,1.109,0,1,0,1.217,1.854,12.927,12.927,0,0,0,0-21.635ZM22,12.124a8.462,8.462,0,0,0-3.931-7.161,1.1,1.1,0,0,0-1.518.342,1.113,1.113,0,0,0,.34,1.529,6.264,6.264,0,0,1,0,10.58,1.113,1.113,0,0,0-.34,1.529,1.1,1.1,0,0,0,1.518.342A8.462,8.462,0,0,0,22,12.124ZM15.5,8.6a1.1,1.1,0,0,0-1.061,1.928,1.807,1.807,0,0,1,0,3.191A1.1,1.1,0,0,0,15.5,15.647a4.007,4.007,0,0,0,0-7.046Z"
				transform="translate(0 -1.125)"
			/>
		</svg>
	);
};

export const NavigateIcon: React.FC = () => {
	return (
		<svg
			data-name="Navigate-Icon"
			xmlns="http://www.w3.org/2000/svg"
			width="19.871"
			height="19.876"
			viewBox="0 0 19.871 19.876">
			<path
				data-name="Navigate Path"
				d="M0,7.8.005,8.923,7.878,12l3.074,7.872,1.125.006L19.871,0Z"
			/>
		</svg>
	);
};

export const VirtualTourIcon: React.FC = () => {
	return (
		<svg
			data-name="VT-Icon"
			xmlns="http://www.w3.org/2000/svg"
			width="17.955"
			height="13.965"
			viewBox="0 0 17.955 13.965">
			<path
				data-name="Virtual Tour Path"
				d="M14.962,14.22v.5a1.5,1.5,0,0,1-1.5,1.5H1.5a1.5,1.5,0,0,1-1.5-1.5V6.739a1.5,1.5,0,0,1,1.5-1.5h.5v6.484A2.5,2.5,0,0,0,4.489,14.22Zm2.992-2.494V3.746a1.5,1.5,0,0,0-1.5-1.5H4.489a1.5,1.5,0,0,0-1.5,1.5v7.98a1.5,1.5,0,0,0,1.5,1.5h11.97A1.5,1.5,0,0,0,17.955,11.726ZM7.98,5.242a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,7.98,5.242ZM4.987,9.731,6.718,8a.374.374,0,0,1,.529,0L8.479,9.232,12.7,5.008a.374.374,0,0,1,.529,0L15.96,7.736v3.491H4.987Z"
				transform="translate(0 -2.25)"
			/>
		</svg>
	);
};

export const DirectionsIcon: React.FC = () => {
	return (
		<svg
			data-name="Directions-Icon"
			xmlns="http://www.w3.org/2000/svg"
			width="24.018"
			height="24.019"
			viewBox="0 0 24.018 24.019">
			<path
				data-name="Directions Path"
				d="M23.578,10.945,13.073.44a1.505,1.505,0,0,0-2.128,0L.44,10.945a1.505,1.505,0,0,0,0,2.128l10.5,10.5a1.5,1.5,0,0,0,2.128,0l10.5-10.5a1.505,1.505,0,0,0,0-2.128Zm-4.737.589-3.95,3.646a.375.375,0,0,1-.63-.276V12.384h-4.5v3a.375.375,0,0,1-.375.375h-1.5a.375.375,0,0,1-.375-.375V11.634a1.5,1.5,0,0,1,1.5-1.5H14.26V7.612a.375.375,0,0,1,.63-.276l3.95,3.646a.376.376,0,0,1,0,.552Z"
			/>
		</svg>
	);
};

export const DownloadIcon: React.FC = () => {
	return (
		<svg
			data-name="Download-Icon"
			xmlns="http://www.w3.org/2000/svg"
			width="19.436"
			height="19.941"
			viewBox="0 0 19.436 19.941">
			<path
				d="M8.478,18.134l.988.988a1.064,1.064,0,0,0,1.509,0l8.652-8.648a1.064,1.064,0,0,0,0-1.509L10.975.314a1.064,1.064,0,0,0-1.509,0L8.478,1.3A1.069,1.069,0,0,0,8.5,2.828l5.363,5.109H1.068A1.066,1.066,0,0,0,0,9.006V10.43A1.066,1.066,0,0,0,1.068,11.5H13.859L8.5,16.607A1.062,1.062,0,0,0,8.478,18.134Z"
				transform="translate(19.436) rotate(90)"
			/>
		</svg>
	);
};

export const ForwardArrowIcon: React.FC = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="19.436"
			height="19.941"
			viewBox="0 0 19.436 19.941">
			<path
				id="icon-arrow-left"
				d="M8.478,18.134l.988.988a1.064,1.064,0,0,0,1.509,0l8.652-8.648a1.064,1.064,0,0,0,0-1.509L10.975.314a1.064,1.064,0,0,0-1.509,0L8.478,1.3A1.069,1.069,0,0,0,8.5,2.828l5.363,5.109H1.068A1.066,1.066,0,0,0,0,9.006V10.43A1.066,1.066,0,0,0,1.068,11.5H13.859L8.5,16.607A1.062,1.062,0,0,0,8.478,18.134Z"
				transform="translate(19.436) rotate(90)"
			/>
		</svg>
	);
};

export const BackgroundTest: React.FC = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="367.299"
			height="840.803"
			viewBox="0 0 367.299 840.803">
			<path
				id="Path_33"
				data-name="Path 33"
				d="M-1126-493.175c-13.071,115.6-287.869,146.437-287.869,267.31,0,158,307.461,66.273,307.461,292.491,0,189.463-355.573,40.17-363.235,276.726"
				transform="translate(1471.705 495.387)"
				fill="none"
				strokeLinecap="round"
				strokeWidth="4"
				strokeDasharray="24 30"
			/>
		</svg>
	);
};

export const BackgroundTest2: React.FC = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="397.617"
			height="331.262"
			viewBox="0 0 397.617 331.262">
			<path
				id="Path_33"
				data-name="Path 33"
				d="M-1131.233-102.573c-99.281-12.072-92.609,328.75-218.275,326.956s-17.531-303.1-174.545-244.9"
				transform="translate(1526.624 104.873)"
				fill="none"
				strokeLinecap="round"
				strokeWidth="4"
				strokeDasharray="24 30"
			/>
		</svg>
	);
};

export const BackgroundTest3: React.FC = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="397.617"
			height="640.314"
			viewBox="0 0 397.617 640.314">
			<path
				id="Path_33"
				data-name="Path 33"
				d="M-1131.233-102.573c-41.5-5.046-537.882,97.246-269.812,294.306s232.108-618.593,65.755-605.415c-172.511,34.145-31.75,334.969-188.763,393.168"
				transform="translate(1526.624 415.844)"
				fill="none"
				strokeLinecap="round"
				strokeWidth="4"
				strokeDasharray="24 30"
			/>
		</svg>
	);
};

export const BookmarkIcon: React.FC = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="14.713"
			height="19.923"
			viewBox="0 0 14.713 19.923">
			<path
				d="M20.213,22.423l-6.356-4.979L7.5,22.423V6.491A1.91,1.91,0,0,1,9.316,4.5H18.4a1.91,1.91,0,0,1,1.816,1.991Z"
				transform="translate(-6.5 -3.5)"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
			/>
		</svg>
	);
};

const createActivityIconStub = (label: string) => {
	const ActivityIconStub: React.FC<SVGIconProps> = (props) => (
		<svg
			viewBox="0 0 32 32"
			role="img"
			aria-label={`${label} icon placeholder`}
			{...props}>
			<title>{`${label} icon placeholder`}</title>
			<rect
				width="32"
				height="32"
				rx="6"
				ry="6"
				fill="none"
				stroke="currentColor"
				strokeDasharray="4 4"
			/>
			<line
				x1="6"
				y1="26"
				x2="26"
				y2="6"
				stroke="currentColor"
				strokeDasharray="4 4"
			/>
		</svg>
	);

	ActivityIconStub.displayName = `${label.replace(/\s+/g, '')}ActivityIconStub`;
	return ActivityIconStub;
};

export const ActivityPersonWalkingIcon: React.FC<SVGIconProps> = (props) => {
	const clipBaseId = useId();
	const clipAId = `${clipBaseId}-walking-a`;
	const clipBId = `${clipBaseId}-walking-b`;

	return (
		<svg
			viewBox="0 0 133.333 133.333"
			role="img"
			aria-label="Walking icon"
			{...props}>
			<title>Walking icon</title>
			<defs>
				<clipPath id={clipAId}>
					<path d="M-41.94 38.853h100v-100h-100Z" />
				</clipPath>
				<clipPath id={clipBId}>
					<path d="M-59.691 7.817h100v-100h-100Z" />
				</clipPath>
			</defs>
			<path
				clipPath={`url(#${clipAId})`}
				d="M0 0c-1.527-1.158-2.902-2.253-4.336-3.264-.684-.482-1.011-1.063-1.193-1.866A686 686 0 0 0-8.11-16.002c-.361-1.477-1.522-2.419-3.081-2.604-1.381-.165-2.796.516-3.349 1.792-.255.589-.375 1.363-.234 1.98.999 4.414 2.101 8.804 3.125 13.211.272 1.169.849 2.056 1.797 2.773 4.824 3.652 9.63 7.328 14.449 10.987 4.077 3.095 9.697 1.876 12.137-2.624 2.263-4.174 4.511-8.357 6.805-12.514a4 4 0 0 1 1.25-1.357c3.138-2.065 6.311-4.074 9.469-6.108 1.09-.701 1.691-1.692 1.511-3.002-.172-1.249-.946-2.102-2.107-2.557-1.128-.444-2.229-.289-3.245.354-3.684 2.338-7.374 4.668-11.024 7.057-.55.359-.995.964-1.333 1.545-.886 1.521-1.687 3.093-2.625 4.839-.421-1.7-.8-3.203-1.166-4.708-.706-2.896-1.389-5.797-2.117-8.687-.137-.548-.039-.914.341-1.33 4.12-4.509 8.209-9.046 12.337-13.548.725-.79 1.115-1.675 1.321-2.7a6058 6058 0 0 1 3.44-16.959c.571-2.804-1.109-5.296-3.98-5.884-2.732-.559-5.53 1.212-6.074 3.849-1.103 5.351-2.203 10.705-3.319 16.053-.064.309-.19.655-.401.873-3.439 3.557-6.896 7.095-10.351 10.636-.054.055-.134.085-.29.181-.464-1.958-.922-3.873-1.371-5.789-.353-1.505-.634-3.029-1.067-4.51a10 10 0 0 0-1.154-2.548A2112 2112 0 0 0-8.888-53.518c-2.06-3.162-6.739-3.358-8.815-.407-1.183 1.683-1.166 3.452.082 5.415 2.877 4.52 5.787 9.019 8.627 13.562.557.891 1.011 1.904 1.262 2.923C-5.167-21.603-2.653-11.168-.126-.735c.044.182.064.371.126.735"
				transform="matrix(1.33333 0 0 -1.33333 55.92 51.805)"
				fill="currentColor"
			/>
			<path
				clipPath={`url(#${clipBId})`}
				d="M0 0c4.573-.039 8.111-3.658 8.068-8.254-.041-4.445-3.703-8.015-8.182-7.975-4.493.039-8.106 3.728-8.041 8.212C-8.09-3.538-4.452.039 0 0"
				transform="matrix(1.33333 0 0 -1.33333 79.589 10.423)"
				fill="currentColor"
			/>
		</svg>
	);
};

export const ActivityPersonBikingIcon: React.FC<SVGIconProps> = (props) => {
	const clipBaseId = useId();
	const clipAId = `${clipBaseId}-cycling-a`;
	const clipBId = `${clipBaseId}-cycling-b`;
	const clipCId = `${clipBaseId}-cycling-c`;
	const clipDId = `${clipBaseId}-cycling-d`;

	return (
		<svg
			viewBox="0 0 133.333 133.333"
			role="img"
			aria-label="Cycling icon"
			{...props}>
			<title>Cycling icon</title>
			<defs>
				<clipPath id={clipAId}>
					<path d="M-52.396 34.372h100v-100h-100Z" />
				</clipPath>
				<clipPath id={clipBId}>
					<path d="M-51.902 15.118h100v-100h-100Z" />
				</clipPath>
				<clipPath id={clipCId}>
					<path d="M-40 73H60V-27H-40Z" />
				</clipPath>
				<clipPath id={clipDId}>
					<path d="M-97 73H3V-27H-97Z" />
				</clipPath>
			</defs>
			<path
				clipPath={`url(#${clipAId})`}
				d="m0 0-9.562-9.868c.049-.028.295-.184.551-.319 2.74-1.444 5.468-2.91 8.225-4.321 2.25-1.15 3.319-2.847 3.279-5.465-.104-6.749-.034-13.502-.035-20.253-.001-2.087-1.404-3.889-3.301-4.25-2.134-.407-4.047.592-4.85 2.606-.206.518-.283 1.118-.285 1.681q-.033 7.821.001 15.642c.003.567-.172.872-.669 1.145a2952 2952 0 0 0-14.888 8.256c-2.631 1.467-3.883 3.958-3.385 6.705.226 1.251.842 2.316 1.731 3.21C-18.021-.037-12.854 5.16-7.666 10.333c2.665 2.657 7.247 2.023 9.402-1.303C4.286 5.095 6.802 1.137 9.3-2.831c.353-.561.734-.752 1.384-.745 3.54.043 7.08.042 10.621.046.492.001.989-.021 1.477-.086 1.49-.197 2.543-1.345 2.556-2.754.013-1.449-1.041-2.641-2.551-2.848-.433-.059-.876-.062-1.315-.062-4.391-.004-8.782.031-13.172-.02-1.668-.02-2.807.676-3.665 2.046C3.136-4.862 1.597-2.495 0 0"
				transform="matrix(1.33333 0 0 -1.33333 69.861 45.83)"
				fill="currentColor"
			/>
			<path
				clipPath={`url(#${clipBId})`}
				d="M0 0c.012 4.402 3.605 7.991 8.028 8.019 4.456.027 8.111-3.648 8.082-8.129-.028-4.394-3.667-7.99-8.071-7.974A8.054 8.054 0 0 0 0 0"
				transform="matrix(1.33333 0 0 -1.33333 69.203 20.157)"
				fill="currentColor"
			/>
			<path
				clipPath={`url(#${clipCId})`}
				d="M0 0c0-9.941-8.059-18-18-18S-36-9.941-36 0s8.059 18 18 18S0 9.941 0 0"
				transform="matrix(1.33333 0 0 -1.33333 53.333 97.333)"
				fill="currentColor"
			/>
			<path
				clipPath={`url(#${clipDId})`}
				d="M0 0c0-9.941-8.059-18-18-18S-36-9.941-36 0s8.059 18 18 18S0 9.941 0 0"
				transform="matrix(1.33333 0 0 -1.33333 129.333 97.333)"
				fill="currentColor"
			/>
		</svg>
	);
};

export const ActivityPeopleGroupIcon: React.FC<SVGIconProps> = (props) => (
	<svg
		viewBox="0 0 133.333 133.333"
		role="img"
		aria-label="Experience nature icon"
		{...props}>
		<title>Experience nature icon</title>
		<path
			d="m 90.95543,27.188942 c -10.72907,3.937218 -5.13422,21.263916 5.96913,17.080246 10.76138,-4.054825 4.77355,-21.022461 -5.96913,-17.080246 M 37.983976,30.174286 C 27.9162,34.255531 34.165495,50.873573 44.92456,46.688942 56.12095,42.334221 49.14735,25.648911 37.983976,30.174286 m 4.956014,45.257713 c 0,3.056305 -0.95681,26.868001 7.39661,19.238426 3.99112,-3.645271 1.60339,-17.173275 1.60339,-22.238426 10.9381,8.670593 1.80768,27.136048 5.43364,38.891201 3.35892,10.88944 8.5647,-3.59463 8.56636,-7.8912 v -9.000001 h 3 c 0,5.092652 -1.52281,13.080401 0.6034,17.770841 1.81019,3.99329 6.79109,2.91863 7.96297,-0.87964 4.13519,-13.40292 -2.03926,-26.581066 4.43363,-39.891201 h 1 c 0,5.522297 -1.49276,13.672844 0.89352,18.771607 1.48587,3.174865 5.84769,3.796539 7.92748,0.793975 3.56911,-5.152671 -1.68183,-13.312805 3.179,-17.565582 0,4.894379 -1.36921,12.262093 0.74229,16.771607 1.8635,3.979858 7.09073,3.15747 8.34568,-0.830246 3.2288,-10.259789 -3.93274,-23.893799 1.09104,-33.941361 1.98916,-3.978325 15.11667,-12.694473 11.15896,-17.522377 -2.11307,-2.577675 -5.29345,-0.838112 -7.33797,0.766205 C 102.49751,43.731171 96.97487,49.159752 87.94,45.828606 83.90499,44.340904 76.4548,32.929092 71.70157,37.334007 c -3.4384,3.186432 2.21475,8.004212 4.2392,10.097992 6.96009,7.198479 8.72234,16.074028 -3.00078,20.396603 -5.79304,2.136028 -20.4915,-0.846813 -19.36882,-9.396603 0.55724,-4.243759 6.61085,-7.85926 9.13657,-11 1.62898,-2.025635 3.99209,-6.007232 0.78318,-7.913582 -3.47093,-2.062011 -7.37857,2.878708 -9.55093,4.87423 -4.57489,4.202476 -8.81538,5.516777 -14.999995,4.980713 -5.366104,-0.465119 -14.904999,-13.791001 -19.377315,-9.31868 -3.379613,3.379616 2.239718,8.179336 4.381173,10.377319 9.628231,9.882408 6.928415,22.008755 6.996913,35 0.01803,3.420014 -0.08272,10.381302 4.999229,10.248459 7.147145,-0.186829 2.603128,-15.942669 6.999995,-20.248459 M 63.95852,49.175056 c -10.99089,4.306237 -3.85772,20.753437 6.96295,16.513886 10.9909,-4.306244 3.85771,-20.753433 -6.96295,-16.513886 z"
			fill="currentColor"
		/>
	</svg>
);

export const ActivityHorseIcon: React.FC<SVGIconProps> = (props) => {
	const clipBaseId = useId();
	const clipAId = `${clipBaseId}-horse-a`;
	const clipBId = `${clipBaseId}-horse-b`;

	return (
		<svg
			viewBox="0 0 133.333 133.333"
			role="img"
			aria-label="Horse riding icon"
			{...props}>
			<title>Horse riding icon</title>
			<defs>
				<clipPath id={clipAId}>
					<path d="M-53.249 19.581h100v-100h-100Z" />
				</clipPath>
				<clipPath id={clipBId}>
					<path d="M-79.941 43.652h100v-100h-100Z" />
				</clipPath>
			</defs>
			<path
				clipPath={`url(#${clipAId})`}
				d="M0 0c2.859 1.076 4.331 4.304 3.267 7.159-1.087 2.911-4.362 4.393-7.244 3.277-2.86-1.109-4.304-4.322-3.226-7.178A5.584 5.584 0 0 1 0 0"
				transform="matrix(1.33333 0 0 -1.33333 70.999 26.108)"
				fill="currentColor"
			/>
			<path
				clipPath={`url(#${clipBId})`}
				d="m0 0 3.754 7.475 6.393-1.22C9.642 2.792 5.39-1.186 0 0m16.571 13.378c-3.87 2.593-7.736 5.193-11.639 7.736-.707.46-.883.918-.77 1.715.204 1.429.34 2.867.484 4.304.035.34-.573.574-.822.316l-.278-.288c-7.705-7.978-15.415-15.952-23.11-23.941-.438-.455-.875-.665-1.515-.653-.395.008-.79.005-1.185.009l-.023.063c-.619 1.706-1.732 2.542-3.473 2.734-2.136.234-4.265.511-6.397.772-.199.024-.397.065-.436.071l3.765 8.754c1.65-1.223 3.231-2.379 4.793-3.559.893-.676 1.804-.847 2.88-.423 2.833 1.116 5.688 2.176 8.533 3.261.284.108.571.219.837.365.928.507 1.317 1.538.952 2.475-.356.91-1.322 1.395-2.337 1.155a8 8 0 0 1-.978-.309c-2.294-.875-4.589-1.748-6.873-2.648-.419-.165-.713-.136-1.081.141a741 741 0 0 1-7.828 5.823c-2.216 1.625-5.343.906-6.415-1.473-2.088-4.633-4.155-9.275-6.223-13.916-.357-.799-.493-1.641-.331-2.508.048-.261.122-.508.21-.746-7.485.002-15.428-.018-18.361-.099-5.069-.14-8.65-4.062-8.66-9.115-.009-4.631-.003-9.262 0-13.893 0-.296.026-.592.039-.871h6.398c0 3.941.107 7.808-.042 11.664-.085 2.162.326 4.02 1.714 5.686.565.677.991 1.47 1.559 2.331.063-.268.088-.326.088-.383.004-3.957.01-7.913.005-11.869-.003-1.809.34-3.722-.144-5.394-.474-1.639-1.8-3.032-2.751-4.533-.033-.052-.077-.101-.094-.158-.12-.398-.333-.797-.335-1.197q-.03-11.04.002-22.082a4.1 4.1 0 0 1 .335-1.594c.836-1.882 2.7-2.783 4.688-2.336 1.792.402 3.084 2.094 3.086 4.062.004 4.907.168 9.822-.058 14.719-.153 3.337.433 6.267 2.605 8.845.513.609.884 1.339 1.319 2.014.164-1.97.151-3.865.174-5.759.005-.418.059-.866.22-1.246q4.285-10.155 8.619-20.291c.187-.438.471-.871.81-1.204 1.458-1.43 3.584-1.589 5.217-.438 1.634 1.152 2.13 3.127 1.31 5.07a2999 2999 0 0 0-7.53 17.959c-.145.35-.098.907.086 1.245.907 1.668 1.92 3.279 2.83 4.945.327.596.705.78 1.37.778 6.195-.026 12.39-.016 18.586-.016h1.068v-1.196q-.003-12.604.002-25.21c0-.396-.003-.804.085-1.187.472-2.069 2.366-3.406 4.433-3.161 2.131.252 3.603 1.889 3.606 4.056.01 8.373 0 16.746.027 25.119.002.586.146 1.221.401 1.748 2.166 4.497 4.372 8.975 6.568 13.458.78 1.591 1.565 3.18 2.362 4.8 3-.737 5.831-.419 8.472 1.114 2.643 1.533 4.291 3.858 5.117 6.733 1.026 0 2.007-.178 2.895.038 1.687.41 2.742 1.595 3.018 3.334.286 1.801-.353 3.262-1.879 4.284"
				transform="matrix(1.33333 0 0 -1.33333 106.589 58.203)"
				fill="currentColor"
			/>
		</svg>
	);
};

export const ActivityUtensilsIcon: React.FC<SVGIconProps> = (props) => {
	const clipBaseId = useId();
	const clipAId = `${clipBaseId}-picnics-a`;
	const clipBId = `${clipBaseId}-picnics-b`;

	return (
		<svg
			viewBox="0 0 133.333 133.333"
			role="img"
			aria-label="Picnics icon"
			{...props}>
			<title>Picnics icon</title>
			<defs>
				<clipPath id={clipAId}>
					<path d="M-39.185 53.184h100v-100h-100Z" />
				</clipPath>
				<clipPath id={clipBId}>
					<path d="M-39.185 53.184h100v-100h-100Z" />
				</clipPath>
			</defs>
			<path
				clipPath={`url(#${clipAId})`}
				d="M0 0h21.363c-2.967 6.815-5.909 13.477-8.741 20.184-.451 1.067-1.102 1.017-1.949 1.03-.868.013-1.519-.005-1.954-1.045C6.504 14.88 4.182 9.635 1.897 4.373zm22.449 21.203c.238-.604.375-.99.538-1.365 2.717-6.259 5.459-12.507 8.13-18.784.397-.932.886-1.199 1.863-1.192 6.457.046 12.914.027 19.37.023 2.691-.002 3.413-.737 3.414-3.443 0-.461.019-.922-.006-1.382-.075-1.33-.82-2.188-2.123-2.407-.491-.083-1-.093-1.5-.093-5.241-.007-10.482-.004-15.723-.004h-1.521c.242-.599.416-1.058.611-1.509q3.85-8.869 7.712-17.734c.838-1.922.623-3.714-.788-5.253-1.342-1.464-3.053-1.859-4.942-1.244-1.388.454-2.313 1.417-2.899 2.77-3.141 7.26-6.326 14.501-9.44 21.773-.393.916-.845 1.226-1.844 1.221-8.427-.044-16.855-.048-25.281.005-1.029.006-1.452-.363-1.829-1.243-3.087-7.193-6.218-14.366-9.337-21.546-1.194-2.751-3.829-3.951-6.329-2.883-2.525 1.079-3.505 3.789-2.318 6.542 2.553 5.919 5.131 11.826 7.696 17.74.163.376.305.762.544 1.361h-1.464q-7.924-.002-15.847 0c-2.798.002-3.521.715-3.521 3.467 0 .545-.025 1.094.027 1.634.127 1.326 1.004 2.157 2.444 2.197 2.011.055 4.024.026 6.036.027 4.821.002 9.644.007 14.465-.007.666-.002 1.159.055 1.48.803 2.839 6.616 5.719 13.214 8.584 19.819.079.183.12.384.217.705h-1.452q-6.855-.002-13.709.001c-2.703.001-3.461.748-3.463 3.394-.001.587-.007 1.174.001 1.76.025 1.813.846 2.688 2.651 2.814.375.025.753.008 1.13.008h53.329c3.131 0 3.792-.652 3.793-3.732 0-3.788-.459-4.243-4.289-4.243z"
				transform="matrix(1.33333 0 0 -1.33333 52.246 70.911)"
				fill="currentColor"
			/>
			<path
				clipPath={`url(#${clipBId})`}
				d="M0 0h21.363c-2.967 6.815-5.909 13.477-8.741 20.184-.451 1.067-1.102 1.017-1.949 1.03-.868.013-1.519-.005-1.954-1.045C6.504 14.88 4.182 9.635 1.897 4.373zm22.449 21.203c.238-.604.375-.99.538-1.365 2.717-6.259 5.459-12.507 8.13-18.784.397-.932.886-1.199 1.863-1.192 6.457.046 12.914.027 19.37.023 2.691-.002 3.413-.737 3.414-3.443 0-.461.019-.922-.006-1.382-.075-1.33-.82-2.188-2.123-2.407-.491-.083-1-.093-1.5-.093-5.241-.007-10.482-.004-15.723-.004h-1.521c.242-.599.416-1.058.611-1.509q3.85-8.869 7.712-17.734c.838-1.922.623-3.714-.788-5.253-1.342-1.464-3.053-1.859-4.942-1.244-1.388.454-2.313 1.417-2.899 2.77-3.141 7.26-6.326 14.501-9.44 21.773-.393.916-.845 1.226-1.844 1.221-8.427-.044-16.855-.048-25.281.005-1.029.006-1.452-.363-1.829-1.243-3.087-7.193-6.218-14.366-9.337-21.546-1.194-2.751-3.829-3.951-6.329-2.883-2.525 1.079-3.505 3.789-2.318 6.542 2.553 5.919 5.131 11.826 7.696 17.74.163.376.305.762.544 1.361h-1.464q-7.924-.002-15.847 0c-2.798.002-3.521.715-3.521 3.467 0 .545-.025 1.094.027 1.634.127 1.326 1.004 2.157 2.444 2.197 2.011.055 4.024.026 6.036.027 4.821.002 9.644.007 14.465-.007.666-.002 1.159.055 1.48.803 2.839 6.616 5.719 13.214 8.584 19.819.079.183.12.384.217.705h-1.452q-6.855-.002-13.709.001c-2.703.001-3.461.748-3.463 3.394-.001.587-.007 1.174.001 1.76.025 1.813.846 2.688 2.651 2.814.375.025.753.008 1.13.008h53.329c3.131 0 3.792-.652 3.793-3.732 0-3.788-.459-4.243-4.289-4.243z"
				transform="matrix(1.33333 0 0 -1.33333 52.246 70.911)"
				fill="currentColor"
			/>
		</svg>
	);
};

export const ActivityStarIcon: React.FC<SVGIconProps> = (props) => {
	const clipBaseId = useId();
	const clipIds = {
		a: `${clipBaseId}-stargazing-a`,
		b: `${clipBaseId}-stargazing-b`,
		c: `${clipBaseId}-stargazing-c`,
		d: `${clipBaseId}-stargazing-d`,
		e: `${clipBaseId}-stargazing-e`,
		f: `${clipBaseId}-stargazing-f`,
	};

	return (
		<svg
			viewBox="0 0 133.333 133.333"
			role="img"
			aria-label="Stargazing icon"
			{...props}>
			<title>Stargazing icon</title>
			<defs>
				<clipPath id={clipIds.a}>
					<path d="M-23.194 9.55h100v-100h-100Z" />
				</clipPath>
				<clipPath id={clipIds.b}>
					<path d="M-61.127 67.24h100v-100h-100Z" />
				</clipPath>
				<clipPath id={clipIds.c}>
					<path d="M-50.89 29.908h100v-100h-100Z" />
				</clipPath>
				<clipPath id={clipIds.d}>
					<path d="M-11.72 50.142h100v-100h-100Z" />
				</clipPath>
				<clipPath id={clipIds.e}>
					<path d="M-71.23 48.79h100v-100h-100Z" />
				</clipPath>
				<clipPath id={clipIds.f}>
					<path d="M-62.72 10.142h100v-100h-100Z" />
				</clipPath>
			</defs>
			<path
				clipPath={`url(#${clipIds.a})`}
				d="m0 0 3.454-6.997a1.33 1.33 0 0 1 1.003-.729l7.722-1.122c1.092-.159 1.529-1.502.738-2.272l-5.588-5.446a1.33 1.33 0 0 1-.383-1.18l1.319-7.691c.187-1.088-.955-1.917-1.932-1.404L-.574-23.21a1.33 1.33 0 0 1-1.24 0l-6.907-3.631c-.977-.513-2.119.316-1.933 1.404l1.319 7.691c.074.433-.069.873-.383 1.18l-5.588 5.446c-.79.77-.354 2.113.739 2.272l7.722 1.122a1.33 1.33 0 0 1 1.003.729L-2.389 0C-1.9.99-.488.99 0 0"
				transform="matrix(1.33333 0 0 -1.33333 30.926 12.734)"
				fill="currentColor"
			/>
			<path
				clipPath={`url(#${clipIds.b})`}
				d="m0 0-2.506-7.39a1.33 1.33 0 0 1 .194-1.224l4.667-6.254c.66-.885.02-2.143-1.084-2.129l-7.803.1a1.33 1.33 0 0 1-1.105-.563l-4.505-6.371c-.638-.901-2.032-.681-2.36.374l-2.316 7.451c-.13.419-.458.747-.877.877l-7.451 2.316c-1.055.328-1.275 1.722-.374 2.36l6.371 4.506c.358.253.568.666.563 1.104l-.1 7.803c-.014 1.103 1.244 1.744 2.129 1.084l6.253-4.667c.352-.262.81-.334 1.225-.193l7.39 2.505C-.644 2.044.354 1.046 0 0"
				transform="matrix(1.33333 0 0 -1.33333 81.503 89.654)"
				fill="currentColor"
			/>
			<path
				clipPath={`url(#${clipIds.c})`}
				d="m0 0 2.57-5.208a.99.99 0 0 1 .746-.542l5.747-.835a.991.991 0 0 0 .549-1.691L5.454-12.33a.99.99 0 0 1-.285-.877l.982-5.724a.992.992 0 0 0-1.439-1.045l-5.14 2.703a1 1 0 0 1-.923 0l-5.14-2.703a.991.991 0 0 0-1.438 1.045l.982 5.724a1 1 0 0 1-.285.877l-4.159 4.054a.992.992 0 0 0 .55 1.691l5.746.835c.324.047.602.25.747.542L-1.778 0A.992.992 0 0 0 0 0"
				transform="matrix(1.33333 0 0 -1.33333 67.852 39.878)"
				fill="currentColor"
			/>
			<path
				clipPath={`url(#${clipIds.d})`}
				d="m0 0 5.5-1.864a.99.99 0 0 1 .911.143l4.654 3.474a.991.991 0 0 0 1.584-.808l-.074-5.806a.99.99 0 0 1 .419-.823l4.741-3.352a.991.991 0 0 0-.278-1.756l-5.546-1.724a.99.99 0 0 1-.652-.652l-1.724-5.546a.991.991 0 0 0-1.756-.278l-3.353 4.741a.99.99 0 0 1-.822.419l-5.807-.074a.991.991 0 0 0-.807 1.584L.463-7.668a.99.99 0 0 1 .144.911l-1.864 5.5A.991.991 0 0 0 0 0"
				transform="matrix(1.33333 0 0 -1.33333 15.628 66.855)"
				fill="currentColor"
			/>
			<path
				clipPath={`url(#${clipIds.e})`}
				d="m0 0 5.208 2.57a1 1 0 0 1 .542.746l.835 5.747a.991.991 0 0 0 1.691.549l4.054-4.158a.99.99 0 0 1 .877-.285l5.723.981a.991.991 0 0 0 1.046-1.437L17.273-.428a.99.99 0 0 1 0-.923l2.703-5.139a.992.992 0 0 0-1.046-1.439l-5.723.982a.99.99 0 0 1-.877-.285l-4.054-4.159a.992.992 0 0 0-1.691.55L5.75-5.095a.99.99 0 0 1-.542.747L0-1.778A.991.991 0 0 0 0 0"
				transform="matrix(1.33333 0 0 -1.33333 94.974 65.052)"
				fill="currentColor"
			/>
			<path
				clipPath={`url(#${clipIds.f})`}
				d="m0 0 5.5-1.864a.99.99 0 0 1 .911.143l4.654 3.474a.991.991 0 0 0 1.584-.808l-.074-5.806a.99.99 0 0 1 .419-.823l4.741-3.352a.991.991 0 0 0-.278-1.756l-5.546-1.724a.99.99 0 0 1-.652-.652l-1.724-5.546a.991.991 0 0 0-1.756-.278l-3.353 4.741a.99.99 0 0 1-.822.419l-5.807-.074a.991.991 0 0 0-.807 1.584L.463-7.668a.99.99 0 0 1 .144.911l-1.864 5.5A.991.991 0 0 0 0 0"
				transform="matrix(1.33333 0 0 -1.33333 83.628 13.522)"
				fill="currentColor"
			/>
		</svg>
	);
};

export const ActivityBirdwatchingIcon: React.FC<SVGIconProps> = (props) => {
	return (
		<svg
			viewBox="0 0 133.333 133.333"
			role="img"
			aria-label="Birdwatching icon"
			preserveAspectRatio="xMidYMid meet"
			{...props}>
			<title>Birdwatching icon</title>
			<path
				d="M0 0a1.902 1.902 0 1 1 3.803.054 1.88 1.88 0 0 1-1.928 1.849A1.876 1.876 0 0 1 0 0m23.762-5.083c-1.546-.76-2.981-1.466-4.418-2.17-1.823-.894-3.641-1.801-5.476-2.67-.412-.196-.543-.43-.538-.878.025-2.054.038-4.109.006-6.163C13.168-27.647 8.745-36.147.065-42.35c-5.266-3.764-11.232-5.487-17.701-5.485q-12.281.003-24.562.003c-1.8.001-5.04 1.703-1.92 5.888C-32.372-26.192-21.586-9.746-10.304 6.341c4.567 6.513 13.452 7.582 19.357 2.335 2.33-2.07 3.728-4.694 4.143-7.799.081-.604.307-.939.871-1.209 3.008-1.432 5.991-2.914 8.982-4.38.198-.097.391-.204.713-.371"
				transform="matrix(1.33333 0 0 -1.33333 81.651 46.495)"
				fill="currentColor"
			/>
		</svg>
	);
};

export const ActivityDefaultIcon = createActivityIconStub('Activity');

export type ActivityIconComponent = React.FC<SVGIconProps>;

export const activityIconComponents: Record<string, ActivityIconComponent> = {
	'person-walking': ActivityPersonWalkingIcon,
	walking: ActivityPersonWalkingIcon,
	'person-biking': ActivityPersonBikingIcon,
	cycling: ActivityPersonBikingIcon,
	'people-group': ActivityPeopleGroupIcon,
	experience: ActivityPeopleGroupIcon,
	horse: ActivityHorseIcon,
	'horse-riding': ActivityHorseIcon,
	utensils: ActivityUtensilsIcon,
	picnics: ActivityUtensilsIcon,
	star: ActivityStarIcon,
	stargazing: ActivityStarIcon,
	birdwatching: ActivityBirdwatchingIcon,
};

export const resolveActivityIcon = (
	...keys: Array<string | null | undefined>
): ActivityIconComponent => {
	for (const key of keys) {
		if (!key) {
			continue;
		}

		const normalizedKey = key.trim().toLowerCase();

		if (!normalizedKey) {
			continue;
		}

		const match = activityIconComponents[normalizedKey];

		if (match) {
			return match;
		}
	}

	return ActivityDefaultIcon;
};
